"use client";

import { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
import { urlFor } from "@/sanity/lib/image";
import Image from "next/image";
import { useTheme } from "@/contexts/ThemeContext";

type AuthorProps = {
  author: NonNullable<POST_BY_SLUG_QUERYResult>["author"];
};

export function Author({ author }: AuthorProps) {
  const { themeColors } = useTheme();

  return author?.image || author?.name ? (
    <a href="/about" className="flex items-center gap-2">
      {author?.image ? (
        <Image
          src={urlFor(author.image).width(40).height(40).url()}
          width={40}
          height={40}
          alt={author.name || ""}
          className="bg-pink-50 size-8 shadow-inner rounded-full"
        />
      ) : null}
      {author?.name ? (
        <p className={`text-xsmall ${themeColors.authorColor}`}>
          {author.name}
        </p>
      ) : null}
    </a>
  ) : null;
}
